import axios from "axios";

export const enviarMensajesMas = async (entidad) => {

    let data = JSON.stringify(entidad);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/1a2aaeac-e869-41f9-9f4d-752508e4155c', //test
      //  url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/1a2aaeac-e869-41f9-9f4d-752508e4155c',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
            return true
        })
        .catch((error) => {
            console.log(error);
            return false
        });

}